import { render, staticRenderFns } from "./UpdateFlow.vue?vue&type=template&id=447a3cdc&scoped=true"
import script from "./UpdateFlow.vue?vue&type=script&lang=js"
export * from "./UpdateFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a3cdc",
  null
  
)

export default component.exports